import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireImage} from '../umpire-image';

export interface UmpireComponentImage
  extends UmpireComponent<UmpireComponentTypeEnum.IMAGE> {
  image: UmpireImage;
  external_url?: string;
  description: string;
}
